import * as _ from "lodash-es";
import {h as createElement} from "vue";
import {ElRow as Row, ElCol as Col, ElFormItem as FormItem, ElInput as Input} from "element-plus";

const getComp = function (item, state, callback) {
  const props = {};
  if (item.props) {
    Object.assign(props, item.props);
  }
  const onUpdate = function (value) {
    if (callback) {
      callback(value);
    }
  };
  const onInput = function (e) {
    if (item.key) {
      if (e && e.target) {
        const target = e.target;
        if ('value' in target) {
          const data = {[item.key]: target.value};
          onUpdate(data);
        }
      } else {
        onChange(e);
      }
    }
  }
  const onChange = function (value) {
    if (item.key) {
      const data = {[item.key]: value};
      onUpdate(data);
    }
  }
  Object.assign(props, {onInput, onChange});
  if (item.key) {
    const value = state[item.key] || void 0;
    Object.assign(props, {value, modelValue: value});
  }
  if (item.component) {
    return createElement(item.component, props, item.slots);
  }
  return createElement(Input, props, item.slots);
}

const formItem = function (props, state, onUpdateValue) {
  let label;
  const className = _.compact(_.concat([], props["class"]));
  const tmp = props.label;
  if (!_.isNil(tmp)) {
    label = tmp ? tmp : (<span>&nbsp;</span>);
  }
  if (props.from === false) {
    const opt = {"class": className};
    return createElement("div", opt, getComp(props, state, onUpdateValue));
  } else {
    const opt = {"class": className, prop: props.key, rules: props.rules};
    const slots = {label, default: getComp(props, state || {}, onUpdateValue)};
    return createElement(FormItem, opt, slots);
  }
}

export const render = function (config, state, onUpdateValue) {
  if (config && Array.isArray(config)) {
    return (<Row gutter={24}>
      {
        config.map((item) => {
          return (<Col span={Math.ceil(24 / config.length)}>{render(item, state, onUpdateValue)}</Col>);
        })
      }
    </Row>);
  }

  if (config && config.children) {
    const className = _.compact(_.concat([], config["class"]));
    const children = [];
    const opt = {"class": className};
    const list = _.concat([], config.children);
    for (const item of list) {
      if (item) {
        const temp = render(item, state, onUpdateValue);
        if (temp) {
          children.push(temp);
        }
      }
    }
    return createElement(config.component || "div", opt, children);
  } else if (config) {
    return formItem(config, state, onUpdateValue);
  }
}